<template>
    <div class="relative inline-block text-left">
        <template v-if="squareButton">
            <button
                @click="open = !open"
                type="button"
                class="inline-flex items-center px-1.5 py-1.5 border border-transparent text-xs font-medium rounded text-indigo-700 bg-indigo-100 hover:bg-indigo-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
            >
                <svg class="w-4 h-4" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M5 4a1 1 0 00-2 0v7.268a2 2 0 000 3.464V16a1 1 0 102 0v-1.268a2 2 0 000-3.464V4zM11 4a1 1 0 10-2 0v1.268a2 2 0 000 3.464V16a1 1 0 102 0V8.732a2 2 0 000-3.464V4zM16 3a1 1 0 011 1v7.268a2 2 0 010 3.464V16a1 1 0 11-2 0v-1.268a2 2 0 010-3.464V4a1 1 0 011-1z"
                    ></path>
                </svg>
            </button>
        </template>
        <template v-else>
            <AppButton @click="open = !open" type="button" desired-action>
                <svg class="w-4 h-4 mr-1" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M5 4a1 1 0 00-2 0v7.268a2 2 0 000 3.464V16a1 1 0 102 0v-1.268a2 2 0 000-3.464V4zM11 4a1 1 0 10-2 0v1.268a2 2 0 000 3.464V16a1 1 0 102 0V8.732a2 2 0 000-3.464V4zM16 3a1 1 0 011 1v7.268a2 2 0 010 3.464V16a1 1 0 11-2 0v-1.268a2 2 0 010-3.464V4a1 1 0 011-1z"
                    ></path>
                </svg>
                {{ $t('messages.perform_action') }}
            </AppButton>
        </template>
        <SlideOver size="xxxl" :show="open" @close="open = false">
            <slot>
                <details class="mt-3 sm:col-span-12">
                    <summary>
                        <h2 class="inline-block text-lg leading-6 font-medium text-gray-900 mb-3">
                            {{ $tc('messages.X_students_selected', students.length, { number: students.length }) }}
                        </h2>
                    </summary>
                    <div>
                        <div class="flex -space-x-2 relative z-0 overflow-hidden">
                            <img
                                v-for="(student, index) in students"
                                :key="index"
                                :title="student.full_name"
                                :src="student.avatar_or_default"
                                class="relative z-30 inline-block h-8 w-8 rounded-full ring-2 ring-white"
                                alt=""
                            />
                        </div>
                    </div>
                </details>

                <Tabs class="mt-3">
                    <template v-if="gamificationSet">
                        <Tab :title="$t('messages.reinforcements_positive')" :selected="true">
                            <GiveRewardCurrencyPointsForm
                                :students="students"
                                :rewards="gamificationSet.rewards.filter((r) => !r.is_negative)"
                                @close="open = false"
                            />
                        </Tab>
                        <Tab :title="$t('messages.reinforcements_negative')">
                            <GiveRewardCurrencyPointsForm
                                :students="students"
                                :rewards="gamificationSet.rewards.filter((r) => r.is_negative)"
                                @close="open = false"
                            />
                        </Tab>
                    </template>
                    <Tab :title="$t('messages.reinforcements_free')">
                        <GiveDirectCurrencyPointsForm :students="students" @close="open = false" />
                    </Tab>
                    <Tab :title="$tc('messages.gamification_items', 2)" v-if="items">
                        <GiveItemsForm :students="students" :items="items" @close="open = false" />
                    </Tab>
                </Tabs>
            </slot>
        </SlideOver>
    </div>
</template>

<script>
import GiveDirectCurrencyPointsForm from '@/components/Gamification/GiveDirectCurrencyPointsForm.vue';
import GiveRewardCurrencyPointsForm from '@/components/Gamification/GiveRewardCurrencyPointsForm.vue';
import Tabs from '@/components/Tabs.vue';
import Tab from '@/components/Tab.vue';
import AppButton from '@/components/AppButton.vue';
import GiveItemsForm from '@/components/Gamification/GiveItemsForm.vue';
import SlideOver from '@/components/SlideOver.vue';

export default {
    emits: ['close'],

    components: {
        SlideOver,
        GiveDirectCurrencyPointsForm,
        GiveRewardCurrencyPointsForm,
        GiveItemsForm,
        Tabs,
        Tab,
        AppButton,
    },

    name: 'GiveGroupCurrencyActionsPanel',

    props: {
        students: {
            required: true,
            type: Array,
        },
        gamificationSet: {
            required: false,
            type: Object,
        },
        items: {
            required: false,
            type: Array,
        },
        squareButton: {
            required: false,
            type: Boolean,
            default: false,
        },
    },

    data() {
        return {
            open: false,
        };
    },

    methods: {
        dismiss() {
            this.$emit('close');
        },
    },
};
</script>
